/**
 * Editor reutilizável de lista de strings como chips (Brief 4 · Tela 2 · PR4).
 *
 * Cópia escopada (classes `pe-*`) do ChipListEditor dos Playbooks — acoplamento
 * entre features é pior que ~40 linhas duplicadas, e o CSS já é escopado por tela.
 * Usado em Vocabulário (termos preferidos/a evitar) e Limites éticos (tópicos de
 * redirecionamento / limites de tom). Adiciona via input + Enter/botão; remove via
 * × na chip. Não duplica entradas (trim + dedup).
 */

import { Plus, X } from 'lucide-react';
import { useState } from 'react';

export function PersonaChipEditor({
  values,
  onChange,
  placeholder,
  ariaLabel,
}: {
  values: string[];
  onChange: (next: string[]) => void;
  placeholder: string;
  ariaLabel: string;
}): JSX.Element {
  const [pending, setPending] = useState('');

  const add = (): void => {
    const value = pending.trim();
    if (value === '' || values.includes(value)) {
      setPending('');
      return;
    }
    onChange([...values, value]);
    setPending('');
  };

  const remove = (value: string): void => {
    onChange(values.filter((v) => v !== value));
  };

  return (
    <div className="pe-chip-editor">
      {values.length > 0 && (
        <div className="pe-chip-row">
          {values.map((value) => (
            <span key={value} className="pe-chip pe-chip--editable">
              {value}
              <button
                type="button"
                className="pe-chip__x"
                aria-label={`Remover ${value}`}
                onClick={() => {
                  remove(value);
                }}
              >
                <X size={12} />
              </button>
            </span>
          ))}
        </div>
      )}
      <div className="pe-chip-add">
        <input
          type="text"
          className="pe-input"
          value={pending}
          placeholder={placeholder}
          aria-label={ariaLabel}
          onChange={(e) => {
            setPending(e.target.value);
          }}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              e.preventDefault();
              add();
            }
          }}
        />
        <button type="button" className="pe-btn pe-btn--sm" onClick={add}>
          <Plus size={14} /> Adicionar
        </button>
      </div>
    </div>
  );
}
